export default class Platform {
    static isMobileView(){
        return (window.innerWidth < 767) ? true : false;
    }
}